// extracted by mini-css-extract-plugin
export var productImage = "_oa-1";
export var viewLink = "_oa-2";
export var wishlistItem = "_oa-0";